import * as ActionTypes from '../actionTypes';

// On request
export const getProductionSelectionList = (payload, meta) => ({
  type: ActionTypes.GET_PRODUCT_SELECTION_LIST,
  payload,
  meta
});
// On request success
export const getProductionSelectionListSuccess = (payload, meta) => ({
  type: ActionTypes.GET_PRODUCT_SELECTION_LIST_SUCCESS,
  payload,
  meta
});
// On request failure
export const getProductionSelectionListError = (payload, meta) => ({
  type: ActionTypes.GET_PRODUCT_SELECTION_LIST_ERROR,
  payload,
  meta
});

export const getNewAddonsList = (payload, meta) => ({
  type: ActionTypes.GET_NEW_ADDONS_LIST,
  payload,
  meta
});

export const getNewAddonsListSuccess = (payload, meta) => ({
  type: ActionTypes.GET_NEW_ADDONS_LIST_SUCCESS,
  payload,
  meta
});

export const getNewAddonsListError = (payload, meta) => ({
  type: ActionTypes.GET_NEW_ADDONS_LIST_ERROR,
  payload,
  meta
});

export const resetProductSelectionAddToCart = (payload, meta) => ({
  type: ActionTypes.RESET_PRODUCT_SELECTION_ADD_TO_CART,
  payload,
  meta
});
